import { useEffect, useRef } from "react";

/** The checkbox cell of a table row that can be ticked for a bulk action: always there, so bulk selection is found without hovering
 *  and works on a touch screen. `range` is true when Shift was held: the table then takes the rows in between. */
export function RowCheck({ checked, label, onChange }: { checked: boolean; label: string; onChange: (checked: boolean, range: boolean) => void }) {
  const shift = useRef(false);
  return (
    <td className="ob-dtable__check" onClick={(e) => e.stopPropagation()}>
      <input type="checkbox" className="ob-check" checked={checked} aria-label={label} onClick={(e) => { shift.current = e.shiftKey; }} onChange={(e) => { onChange(e.target.checked, shift.current); shift.current = false; }} />
    </td>
  );
}

/** Ticks or clears everything a list shows. `some` draws the dash: a few are ticked, not all. */
export function SelectAll({ checked, some, onChange, label = "Select all", className }: { checked: boolean; some?: boolean; onChange: (checked: boolean) => void; label?: string; className?: string }) {
  const box = useRef<HTMLInputElement>(null);
  useEffect(() => { if (box.current) box.current.indeterminate = !!some && !checked; }, [some, checked]);
  return <input ref={box} type="checkbox" className={className ? `ob-check ${className}` : "ob-check"} checked={checked} aria-label={label} onChange={(e) => onChange(e.target.checked)} />;
}

/** The header cell of a table: `SelectAll` in its column. */
export function HeadCheck(props: { checked: boolean; some?: boolean; onChange: (checked: boolean) => void }) {
  return <th className="ob-dtable__check"><SelectAll {...props} /></th>;
}
